/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/object-utils/is-array-path */

/**
 * @description Returns true if the passes array segment is an array like path.
 * @param {string} str - String to be tested.
 * @returns {boolean} Result.
 */
function isArrayPath(str) {
  return /^\[\d*]$/.test(str);
}

export { isArrayPath };